import fse from 'fs-extra';
import { Common } from '../common';
import { ErrorUpdater } from './error-updater';
import { FileUpdater } from './file-updater';
import { PackageUpdater } from './package-updater';

export class ExtensionUpgrader {
    /**
     * Driver function of upgrade command. Usage:
     *  --audit - flag set to indicate if running in audit mode (defaults to false, audit mode will not attempt to change files)
     * @param {boolean} audit Flag indicating if upgrade is running it audit mode
     * @param {boolean} internal Flag indicating if upgrade is running for an internal WAC repository
     * @param {string} rootPath Root path of the target repository
     */
    public async upgrade(
        audit: boolean,
        rootPath: string,
        experimental: boolean,
        library: boolean,
        internalOverride: boolean): Promise<void> {
        const updateSource = [];

        Common.rootPath = rootPath;

        const packageUpdater = new PackageUpdater();
        const internal = await packageUpdater.updatePackages(audit, updateSource, experimental);

        const fileUpdater = new FileUpdater();
        fileUpdater.copyNewFiles(audit, internal, updateSource, library, internalOverride);

        const errorUpdater = new ErrorUpdater();
        let errorCount = await errorUpdater.resolveLintErrors(audit, updateSource);
        errorCount += await errorUpdater.resolveBuildErrors(audit, updateSource);

        this.finalize(errorCount, updateSource);
    }

    private finalize(errorCount, updateSource) {
        fse.outputFileSync('UpgradeAudit.txt', updateSource);
        console.log('');
        console.log('|==========================================================|');
        console.log(` There is(are) ${errorCount} unresolved error(s) that need to be handled.`);
        console.log(` A log is available at ${process.cwd()}\\UpgradeAudit.txt`);
        console.log('|==========================================================|');
    }
}
